module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-global-image-sp-72a6231c5058fca615ef27c8cd05b033.png";